import { React, useState, useEffect } from "react";
import axios from "axios";
import PropTypes from "prop-types";
import { CreateValidateTextField } from "..";
import { Dialog, DialogTitle, Snackbar, Alert } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";

function SkillEdit(props) {
  const { updateTable, setUpdateTable, skill } = props;
  const [openEditDialog, setOpenEditDialog] = useState(false);

  const [skillName, setSkillName] = useState(skill.tagName);

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  useEffect(() => {
    // Set the fields back to the skill's data
    setSkillName(skill.tagName);
  }, [skill, openEditDialog]);

  const handleEditSkill = (event) => {
    event.preventDefault();
    const body = new FormData();
    body.append("tagId", skill.tagId);
    body.append("skillName", skillName);
    axios.post("/company/editSkill", body).then((res) => {
      const data = res.data;
      if (data.success) {
        resetHooks();
        setOpenEditDialog(false);
        setUpdateTable(!updateTable);
      } else {
        setSnackbarMessage(data.message);
        setSnackbarOpen(true);
      }
    });
  };

  const resetHooks = () => {
    setSkillName("");
  };

  function showEditDialog() {
    return (
      <Dialog open={openEditDialog} maxWidth={false}>
        <DialogTitle className="SkillEdit-title mx-auto text-2xl font-bold font-brand-primary mt-4">
          Edit Skill
        </DialogTitle>
        <div className="SkillEdit-modalContainer flex flex-col w-fit mb-4">
          <div className="SkillEdit-skillContainer flex flex-col w-96 mx-auto mb-2">
            <div className="SkillEdit-skill text-lg font-brand-primary">
              Skill *
            </div>
            <CreateValidateTextField
              placeholder="Python"
              pattern="(?=.*\w).+"
              value={skillName}
              setter={setSkillName}
              errorMessage={"Invalid Skill."}
              required={true}
            />
          </div>
          <div className="SkillEdit-buttonContainer flex justify-between px-12 mt-4">
            <button
              type="button"
              className="primary-button bg-brand-quaternary mb-2 h-11 pt-3 mr-4"
              onClick={handleEditSkill}
            >
              Update Skill
            </button>

            <button
              type="button"
              className="primary-button bg-brand-primary mb-2 h-11 pt-3"
              onClick={() => setOpenEditDialog(false)}
            >
              Cancel
            </button>
          </div>
        </div>
        <Snackbar
          open={snackbarOpen}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          autoHideDuration={6000}
          onClose={() => {
            setSnackbarOpen(false);
            setSnackbarMessage("");
          }
          }
        >
          <Alert
            onClose={() => {
              setSnackbarOpen(false);
              setSnackbarMessage("");
            }
            }
            severity="error"
            sx={{ width: "100%" }}
          >
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </Dialog>
    );
  }

  return (
    <div className="SkillEdit-container">
      {showEditDialog()}
      <button className="flex mr-4" onClick={() => setOpenEditDialog(true)}>
        <EditIcon fontSize="large" className="fill-brand-quaternary" />
      </button>
    </div>
  );
}

SkillEdit.propTypes = {
  updateTable: PropTypes.bool,
  setUpdateTable: PropTypes.func,
  skill: PropTypes.shape({
    tagId: PropTypes.number,
    tagName: PropTypes.number,
  }),
};

SkillEdit.defaultProps = {
  updateTable: false,
  setUpdateTable: () => { },
  skill: {},
};

export default SkillEdit;
